module.exports = __webpack_public_path__ + "static/media/join-room-icon.121b0416.svg";